export default "__VITE_ASSET__D5bfUsi7__"